export default __webpack_public_path__ + "static/media/shoppinglist@2x.d3b01bc4.png";